import { useApi } from '@/api';
import { KpiCard, KpiSkeleton, Link } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, LinkWrapper } from '@blockanalitica/ui';

export default function RiskKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/at-risk-overview/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  const [coreData, coreError] = useApi({
    url: '/groups/core/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }
  if (coreError) {
    throw coreError;
  }
  if (data && coreData) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to="cdps"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="N° of Vaults"
              data={coreData}
              field="num_urns"
              options={{ linkArrow: true }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/liquidations"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="Debt Liquidated"
              data={data}
              field="debt_liquidated"
              options={{
                linkArrow: true,
                valueOptions: {
                  currencyValueOptions: {
                    currency: tokensMapping('DAI'),
                    iconSize: '4'
                  }
                }
              }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/cdps-at-risk"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="CDPs at Risk"
              data={data}
              field="number_of_cdps"
              options={{
                linkArrow: true
              }}
            />
          </LinkWrapper>
        </Flex>
      </Flex>
    );
  }

  return (
    <>
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
    </>
  );
}
